import { useCallback, useEffect, useState } from 'react';
import * as L from 'leaflet';
import { MapCanvas } from '@seller/map/MapCanvas';
import { DeliveryMapBounds, DeliveryMapZone } from './deliveryMapTypes';
import { positionDeliveryMapGeometry } from './deliveryMapGeometry';

interface LiveDeliveryGeometryMapProps {
  zones: DeliveryMapZone[];
  onBoundsChange: (bounds: DeliveryMapBounds) => void;
}

export function LiveDeliveryGeometryMap({ zones, onBoundsChange }: LiveDeliveryGeometryMapProps) {
  const [map, setMap] = useState<L.Map | null>(null);
  const [viewport, setViewport] = useState<DeliveryMapBounds | null>(null);
  const onReady = useCallback((readyMap: L.Map) => {
    setMap(readyMap);
    const reportViewport = (): void => {
      const bounds = readyMap.getBounds();
      const currentViewport = { west: bounds.getWest(), south: bounds.getSouth(), east: bounds.getEast(), north: bounds.getNorth() };
      setViewport(currentViewport);
      onBoundsChange(currentViewport);
    };
    readyMap.on('moveend', reportViewport);
    reportViewport();
    return () => { readyMap.off('moveend', reportViewport); };
  }, [onBoundsChange]);

  useEffect(() => {
    if (map === null || viewport === null) return;
    const group = L.layerGroup();
    for (const zone of zones) {
      const geometry = positionDeliveryMapGeometry(zone.zone_coords, viewport);
      const layer = L.geoJSON(geometry, {
        style: { fillColor: zone.zone_fill_color, color: zone.zone_stroke_color },
      });
      const tooltip = document.createElement('span');
      tooltip.textContent = `${zone.zone_name} · ID ${zone.zone_id} · ${zone.zone_code ?? '—'} · map ID ${zone.zone_map_id ?? '—'}`;
      layer.eachLayer((featureLayer) => { featureLayer.bindTooltip(tooltip); });
      group.addLayer(layer);
    }
    group.addTo(map);
    return () => { group.remove(); };
  }, [map, zones, viewport]);

  return <MapCanvas aria-label="Текущие границы зон доставки" className="delivery-live-map__canvas" onReady={onReady} scrollWheelZoom />;
}
